import { CodeBracketIcon } from "@heroicons/react/20/solid";
import { observer } from "mobx-react-lite";
import { Button } from "src/components/Button";
import { useFeatureFlag } from "src/contexts/posthog.context";
import { useFixtureExport } from "src/dev/useFixtureExport";
import { FLAGS } from "src/posthog/flags";
import type { Editor } from "src/types/Editor";

export const FixtureExportButton = observer(function FixtureExportButton(props: {
  editor: Editor;
}) {
  const enabled = useFeatureFlag(FLAGS.mapExport);
  const { busy, hasBuilding, worldHash, onClick } = useFixtureExport(props.editor);

  if (!enabled) return null;

  const title = busy
    ? "Exporting…"
    : hasBuilding
      ? `Export cost fixture · ${worldHash}`
      : "Export cost fixture (no building yet)";

  return <Button title={title} Icon={CodeBracketIcon} onClick={onClick} />;
});
